var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76831 12.2211H2.70581L9.64331 5.28359L8.72456 4.34609L1.76831 11.3023V12.2211ZM12.0433 4.45859L9.51206 1.94609L10.5058 0.971094C10.7183 0.758594 10.9841 0.652344 11.3031 0.652344C11.6216 0.652344 11.8871 0.758594 12.0996 0.971094L13.0183 1.88984C13.2308 2.11484 13.3433 2.38034 13.3558 2.68634C13.3683 2.99284 13.2621 3.25234 13.0371 3.46484L12.0433 4.45859ZM1.31831 13.3461C1.13081 13.3461 0.971561 13.2806 0.840561 13.1496C0.709061 13.0181 0.643311 12.8586 0.643311 12.6711V11.0961C0.643311 11.0086 0.659061 10.9243 0.690561 10.8433C0.721561 10.7618 0.77456 10.6836 0.84956 10.6086L8.70581 2.75234L11.2371 5.28359L3.38081 13.1398C3.30581 13.2148 3.22781 13.2681 3.14681 13.2996C3.06531 13.3306 2.98081 13.3461 2.89331 13.3461H1.31831ZM9.17456 4.81484L8.72456 4.34609L9.64331 5.28359L9.17456 4.81484Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.99bed42969e7ea4baf4b13ef936652f7.svg";
export { ForwardRef as ReactComponent };